import React from 'react';
import {Grid, GridProps} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  position: 'relative',
  padding: "0em 1em",
}));

type CollapsableCardHeaderContainerProps = GridProps

/**
 * MUI Grid component styled in the SecurSpace way. Used as a container for the header section of the collapsable card suite of components
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardHeaderContainer = ({ children, ...rest }: CollapsableCardHeaderContainerProps) => {
  return <Root container alignItems={'flex-start'} sx={{ mx: -0.5, '& > *': {px: 0.5 } }} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardHeaderContainer };
